import { render } from "./deactivate-warning.vue?vue&type=template&id=beaefe42&lang=pug"
import script from "./deactivate-warning.vue?vue&type=script&lang=js"
export * from "./deactivate-warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__